const initialState = {
    healthPermissions: [],
    healthLists: [],
    healthExcelLists: [],
    healthExcelCount: 0,
    healthExcelPermissions: [],
    healthStatus: [],
    holdWithdrawHealth: [],
    changedHealthStatus: [],
    totalCount: {},
    healthMenuCount: 0,
    reportHtmlJson: "",
    loadingHealth: false,
    loadingHealthExcel: false,
    loadingHealthCounts: false,
    errorsHealth: {}
}

const healthReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_HEALTHLIST_PENDING":
        case "ADD_HEALTH_PENDING":
        case "UPDATE_HEALTH_PENDING":
        case "UPDATE_HEALTH_STATUS_PENDING":
        case "DELETE_HEALTH_PENDING":
        case "GET_HEALTHLISTBYID_PENDING":
        case "GET_HTML_JSON_PENDING":
        case "HOLD_WITHDRAW_HEALTH_PENDING":
            return { ...state, loadingHealth: true };

        case "GET_HEALTHEXCEL_PENDING":
            return { ...state, loadingHealthExcel: true };

        case "HOLD_WITHDRAW_HEALTH_FULFILLED":
            return {
                ...state,
                loadingHealth: false,
                holdWithdrawHealth: action.payload,
                errorsHealth: {}
            };

        case "GET_HEALTHEXCEL_FULFILLED":
            return {
                ...state,
                loadingHealthExcel: false,
                healthExcelLists: action.payload,
                healthExcelCount: action.count,
            };

        case "RESET_HOLD_WITHDRAW_HEALTH":
            return {
                ...state,
                holdWithdrawHealth: [],
            };

        case "GET_HEALTHLIST_FULFILLED":
            // menuCountMap (totalCount) and permissions ab alag endpoint (healthMenuCounts)
            // se aate hain. health-list inhe na bheje to existing values ko clobber na karein.
            return {
                ...state,
                loadingHealth: false,
                healthLists: action.payload,
                healthCount: action.count,
                healthPermissions:
                    action.permissions !== undefined
                        ? action.permissions
                        : state.healthPermissions,
                totalCount:
                    action.totalCount !== undefined
                        ? action.totalCount
                        : state.totalCount,
            };

        case "GET_HEALTH_MENU_COUNTS_PENDING":
            return { ...state, loadingHealthCounts: true };

        case "GET_HEALTH_MENU_COUNTS_FULFILLED":
            return {
                ...state,
                loadingHealthCounts: false,
                healthPermissions:
                    action.permissions !== undefined
                        ? action.permissions
                        : state.healthPermissions,
                totalCount:
                    action.totalCount !== undefined
                        ? action.totalCount
                        : state.totalCount,
                healthMenuCount: action.count,
            };

        case "GET_HEALTH_MENU_COUNTS_REJECTED":
            return {
                ...state,
                loadingHealthCounts: false,
                errorsHealth: action.payload,
            };

        case "GET_HEALTHEXCEL_REJECTED":
            return {
                ...state,
                loadingHealthExcel: false,
                errorsHealth: action.payload,
            };

        case "ADD_HEALTH_FULFILLED":
            return {
                ...state,
                loadingHealth: false,
                changedHealthStatus: action.payload,
                errorsHealth: {}
            };
        case "GET_HTML_JSON_FULFILLED":
            return {
                ...state,
                loadingHealth: false,
                reportHtmlJson: action.payload,
                errorsHealth: {}
            };
        case "UPDATE_HEALTH_FULFILLED":
            return {
                ...state,
                loadingHealth: false,
                changedHealthStatus: action.payload,
                errorsHealth: {}
            };

        case "UPDATE_HEALTH_STATUS_FULFILLED":
            return {
                ...state,
                loadingHealth: false,
                changedHealthStatus: action.payload,
                errorsHealth: {}
            };

        case "GET_HEALTHLISTBYID_FULFILLED":
            return {
                ...state,
                loadingHealth: false,
                healthLists: action.payload
            };

        case "DELETE_HEALTH_FULFILLED":
            return {
                ...state,
                loadingHealth: false,
                changedHealthStatus: action.payload,
                errorsHealth: {}
            };

        case "RESET_DELETE_HEALTHS_STATUS":
            return {
                ...state,
                loadingHealth: false,
                changedHealthStatus: [],
                errorsHealth: {}
            };

        case "SET_HEALTH_ERRORS":
            return {
                ...state,
                loadingHealth: false,
                errorsHealth: action.payload
            };

        case "GET_HEALTHLIST_REJECTED":
        case "ADD_HEALTH_REJECTED":
        case "UPDATE_HEALTH_REJECTED":
        case "UPDATE_HEALTH_STATUS_REJECTED":
        case "DELETE_HEALTH_REJECTED":
        case "GET_HEALTHLISTBYID_REJECTED":
        case "GET_HTML_JSON_REJECTED":
        case "HOLD_WITHDRAW_HEALTH_REJECTED":
            return {
                ...state,
                loadingHealth: false,
                errorsHealth: action.payload
            };

        default:
            return state;
    }
}

export default healthReducer;